import { Box, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/footers/Footer';
import { HomeHeader } from '../../components/headers/HomeHeader';
import { PageMain } from '../../components/seo/PageMain';
import { PageSeoHelmet } from '../../components/seo/PageSeoHelmet';
import { STATIC_PAGE_SEO_META } from '../../components/seo/staticPageSeoMeta';

const primaryBtnClass =
  'inline-flex items-center justify-center rounded-full bg-[#021744] px-8 py-3 text-[16px] font-medium leading-[24px] text-white transition-colors hover:bg-[#22c0b1] hover:text-[#021744]';

const secondaryBtnClass =
  'inline-flex items-center justify-center rounded-full border border-[#021744] bg-transparent px-8 py-3 text-[16px] font-medium leading-[24px] text-[#021744] transition-colors hover:bg-[#021744] hover:text-white';

export function NotFound() {
  return (
    <>
      <PageSeoHelmet {...STATIC_PAGE_SEO_META.notFound} noIndex />
      <div className="w-full overflow-hidden bg-[#F3F4F4]">
        <HomeHeader headerColor="#F9F9F9" textColor="#021744" />
        <PageMain className="not-found-page relative bg-[#F9F9F9]">
          <Box className="absolute left-0 top-0 h-[280px] w-full bg-[#4CFFE9]" aria-hidden />
          <Container maxWidth="md">
            <Box className="relative z-10 mx-auto mt-24 max-w-xl px-4 py-20 text-center sm:px-6 sm:py-28">
              <p className="text-[14px] font-semibold uppercase tracking-[0.2em] text-[#0099B0]">
                Error 404
              </p>
              <h1 className="mt-4 text-[48px] font-medium leading-[1.1] text-[#021744] sm:text-[65px] sm:leading-[71.5px]">
                Page not found
              </h1>
              <p className="mx-auto mt-6 max-w-md text-[16px] leading-[28px] text-[#42506a]">
                The page you are looking for may have been moved, removed, or the address might be
                incorrect. Let us help you get back on track.
              </p>
              <Box
                className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row"
                component="nav"
                aria-label="Helpful links"
              >
                <Link to="/" className={primaryBtnClass}>
                  Back to home
                </Link>
                <Link to="/articles/all" className={secondaryBtnClass}>
                  Explore insights
                </Link>
              </Box>
              <p className="mt-10 text-[15px] text-[#42506a]">
                Need help?{' '}
                <Link to="/contact" className="font-medium text-[#22c0b1] underline-offset-2 hover:underline">
                  Contact our team
                </Link>
              </p>
            </Box>
          </Container>
        </PageMain>
        <Footer />
      </div>
    </>
  );
}
